import { motion } from "framer-motion";
import { MessageCircle, Sparkles, CalendarCheck2, BellRing, Users } from "lucide-react";
import { ChapterHeading } from "@/components/Reveal";

const STEPS = [
  { icon: MessageCircle, title: "Cliente chama no WhatsApp", text: "A qualquer hora, de qualquer lugar. Sem esperar abrir o negócio." },
  { icon: Sparkles, title: "A IA responde na hora", text: "Em segundos, com conversa natural e as informações do seu negócio." },
  { icon: CalendarCheck2, title: "Agendamento concluído", text: "Horário marcado direto na sua agenda, seguindo suas regras." },
  { icon: BellRing, title: "Confirmação automática", text: "Lembrete enviado na véspera. Falta sem aviso vira exceção." },
  { icon: Users, title: "Equipe focada no presencial", text: "Quem está na sua frente recebe 100% da atenção da equipe." },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" data-testid="how-it-works-section" className="relative overflow-hidden py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <ChapterHeading
          index="04"
          eyebrow="Como funciona"
          lines={["Do primeiro “oi”", "à cadeira ocupada."]}
          sub="Cinco etapas que acontecem sozinhas, todos os dias, enquanto sua equipe faz o que só pessoas sabem fazer."
        />

        <div className="relative mt-20">
          <div className="absolute left-6 top-0 h-full w-px bg-[var(--line)] lg:left-0 lg:top-6 lg:h-px lg:w-full" />
          <motion.div
            initial={{ scaleY: 0, scaleX: 0 }}
            whileInView={{ scaleY: 1, scaleX: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
            className="absolute left-6 top-0 h-full w-px origin-top bg-[var(--brand)] lg:left-0 lg:top-6 lg:h-px lg:w-full lg:origin-left"
          />

          <div className="grid gap-12 lg:grid-cols-5 lg:gap-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.title}
                data-testid={`how-step-${i + 1}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="relative pl-16 lg:pl-0 lg:pt-16"
              >
                <div className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-2xl border border-[var(--brand)]/40 bg-[var(--card)] text-[var(--brand)] shadow-[0_8px_20px_-8px_rgba(39,179,176,0.5)] lg:left-0">
                  <s.icon className="h-5 w-5" />
                </div>
                <span className="font-mono2 text-xs tracking-[0.3em] text-[var(--brand)]">0{i + 1}</span>
                <h3 className="mt-2 font-display text-lg font-bold text-[var(--ink)]">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[var(--muted)]">{s.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
